import { render, staticRenderFns } from "./CoResourcePreview.vue?vue&type=template&id=ab58b15e&scoped=true&"
import script from "./CoResourcePreview.vue?vue&type=script&lang=ts&"
export * from "./CoResourcePreview.vue?vue&type=script&lang=ts&"
import style0 from "./CoResourcePreview.vue?vue&type=style&index=0&id=ab58b15e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab58b15e",
  null
  
)

export default component.exports